import api from "./api";

export const newsService = {
  getAllNews: async () => {
    const response = await api.get("/news/getallnews");
    // Backend returns an array directly
    return response.data;
  },

  addNews: async (formData) => {
    const response = await api.post("/news/addnews", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  updateNews: async (id, formData) => {
    const response = await api.put(`/news/updatenews/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  deleteNews: async (id) => {
    const response = await api.delete(`/news/deletenews/${id}`);
    return response.data;
  },
};


